export default "__VITE_ASSET__dQxgwnQP__"